export const CONVERSIONS_QUERY = `
  id
  createdAt
  lastActivityAt
  newMessagesCount
  lastMessage {
    type
    updatedAt
    id
    content
    createdAt
    isSeen
    senderSwapRequest
  }
  swapRequestA {
    id
    user {
      id
      name
      surname
    }
    property {
      propertyType
      numberOfRooms
    }
  }
  swapRequestB {
    id
    user {
      id
      name
      surname
    }
    property {
      propertyType
      numberOfRooms
    }
  }
`;
